/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Insights_Point_AdolescentsInputs */

const en_why_listening_insights_point_adolescents = /** @type {(inputs: Why_Listening_Insights_Point_AdolescentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The effect is strongest in adolescents`)
};

const es_why_listening_insights_point_adolescents = /** @type {(inputs: Why_Listening_Insights_Point_AdolescentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El efecto es más fuerte en adolescentes`)
};

/**
* | output |
* | --- |
* | "The effect is strongest in adolescents" |
*
* @param {Why_Listening_Insights_Point_AdolescentsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_insights_point_adolescents = /** @type {((inputs?: Why_Listening_Insights_Point_AdolescentsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Insights_Point_AdolescentsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_insights_point_adolescents(inputs)
	return en_why_listening_insights_point_adolescents(inputs)
});